import React, { Component } from 'react';

class BifurcationBlock extends Component {
  render() {
    return(
      <div className="block bifurcation-block bifurcation-block-component">
        <div className="custom-tooltip">
          <button type="button" className="custom-tooltip-link" onClick={(e) => e.target.classList.toggle('active')}>
            <span>?</span>
            
            <div className="custom-tooltip-card">
              <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nesciunt illo amet cupiditate tempore veritatis explicabo dolorum hic, placeat dolore, ipsam deleniti dicta suscipit mollitia. Vitae beatae voluptates quos adipisci at?</p>
            </div>
          </button>
        </div>

        <p className="block-title">Bifurcation</p>
        <input type="text" className="form-control"/>
      </div>
    )
  }
}

export { BifurcationBlock as Bifurcation };